import { KycStatusEnum } from '@sparling/financial-common'

const KycStatus = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const status in KycStatusEnum) {
  KycStatus.push({
    value: status,
    label: KycStatusEnum[status as keyof typeof KycStatusEnum],
  })
}

export const KYC_STATUS = KycStatus
